import React, {createContext, useContext} from "react";
import useWindowResize from "../hooks/useWindowResize";

interface IContext {
    itemSize: number;
    panelItemSize: number;
    isTableState: boolean;
    isDesktopState: boolean;
}


export const Context = createContext<IContext | null>(null);

interface IProps {
    children: React.ReactNode;
}

export const ResizeProvider = ({children}: IProps) => {
    const {itemSize, isTableState, isDesktopState} = useWindowResize();
    return (
        <Context.Provider value={{itemSize: itemSize / 1.2, panelItemSize: itemSize / 2, isTableState, isDesktopState}}>
            {children}
        </Context.Provider>
    )
}

export const useViewPortState = () => {
    const context = useContext(Context);

    if (!context) {
        throw new Error('useViewPortState should be use inside ResizeProvider');
    }

    return context;
}

export const useSizeItem = () => {
    const context = useContext(Context);

    if (!context) {
        throw new Error('useSizeItem should be use inside ResizeProvider');
    }

    return context;
};
